import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('UPDATE_FORM_PROPERTIES'),
  SET_FORM_INITIATED: 'SET_FORM_INITIATED',
  SET_FORM_LOADING: 'SET_FORM_LOADING',
  UNSET_FORM_LOADING: 'UNSET_FORM_LOADING',
  SET_FORM_ERROR: 'SET_FORM_ERROR',
  SET_FORM_INFO: 'SET_FORM_INFO',
  SET_FORM_GSIS_AUTH: 'SET_FORM_GSIS_AUTH',
  UNSET_FORM_MESSAGE: 'UNSET_FORM_MESSAGE',
  RESET_FORM: 'RESET_FORM',
};
